import { render, staticRenderFns } from "./assgin.vue?vue&type=template&id=ad6afb74&scoped=true&"
import script from "./assgin.vue?vue&type=script&lang=js&"
export * from "./assgin.vue?vue&type=script&lang=js&"
import style0 from "./assgin.vue?vue&type=style&index=0&id=ad6afb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6afb74",
  null
  
)

export default component.exports